import { render, staticRenderFns } from "./tabTunjangan.vue?vue&type=template&id=4674924a"
import script from "./tabTunjangan.vue?vue&type=script&lang=js"
export * from "./tabTunjangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports